import { z } from "zod";
import { ServerChatMessage } from "@/components/common/section-components/chat/chat-message.types";

export interface CounterDeliveryEntity {
  id: number;
  fechaCreacion: string;
  titular: string;
  monto: number;
  precioFinal: number
  toneladas: number;
  estadoDescripcion: string;
  grano: string;
  sinBase: boolean;
}

export interface CounterDeliveryHarvest {
  cosecha: string;
}

export interface CounterDeliveryListResponse {
  listado: CounterDeliveryEntity[];
  totalPages: number;
  totalRecords: number;
  pendingRequests: boolean;
}

export interface CounterDeliveryDetail {
  id: number;
  montoSolicitado: number;
  saldoActual: number;
  control: boolean;
  fechaSolicitud: string;
  cuentaOrigen: number;
  sucursal: string;
  solicitante: string;
  estado: string;
  mensajes: ServerChatMessage[];
  titular: string;
  esCanje: boolean;
  grano: string;
  cosecha: string;
  toneladas: number;
  precioFinal?: number
  sinBase: boolean;
  mensajesDisponibles?: number;
}

export const counterDeliverySchema = z.object({
  account: z.any().optional(),
  grain: z.any().optional(),
  harvest: z.any().optional(),
  ton: z.any().optional(),
  price: z.any().optional(),
  isExchange: z.boolean().optional().nullish(),
  delivery_detail: z.any().optional(),
  available_ton: z.any().optional(),
});
